import { render, staticRenderFns } from "./profit_center.vue?vue&type=template&id=c8b36d34"
import script from "./profit_center.vue?vue&type=script&lang=js"
export * from "./profit_center.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports